import { post } from 'services/billing'
import { checkRoles } from 'utils'
import { Role } from 'models'

export async function regenerate(
  billingPeriod: string,
  clientId: number
): Promise<{ job_id: string }> {
  await checkRoles([Role.ROOT, Role.MANAGER, Role.FINANCE])
  const response = await post('/invoices/regenerate', {
    attributes: {
      from: billingPeriod,
      client_id: clientId
    }
  })
  return response.data
}
